import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SafeHtml } from "@angular/platform-browser";

export interface AlertDialogData
{
    readonly title?: string;
    readonly message: SafeHtml;
    readonly okLabel?: string;
}

@Component({
    selector: "simple-alert-dialog",
    template: `<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
    <div [innerHtml]="message"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <forge-button variant="raised" mat-dialog-close telemetry="Submission-Save" selenium-tag="save-btn">

            {{okLabel}}
        </forge-button>
</mat-dialog-actions>
`,
    standalone: false
})
export class SimpleAlertDialogComponent
{
    private readonly data = inject<AlertDialogData>(MAT_DIALOG_DATA);


    get title(): string { return this.data.title ?? "Error"; }
    get message(): SafeHtml { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }
}
